<div *ngIf="show" class="d-flex mt-2" [ngClass]="btnPos">
  <div class="btn--load-more" [ngClass]="class" (click)="do.emit()">
    {{ 'common.loadMore' | translate }}
  </div>
</div>
